import { setLogLevel } from '@ms/yammer-console-logging';
import type { SuiteHeaderTheme } from '@ms/yammer-data/dist/state/suiteHeaderTheme/types';
import type { ErrorCode, ReportErrorOptions } from '@ms/yammer-telemetry';
import { getBrowserInfo, getDisplayMode, reportError, reportInfo, reportUsage } from '@ms/yammer-telemetry';
import {
  engageDomain,
  getBasenameForUrlPath,
  getUrlRootPath,
  glammerDomain,
} from '@ms/yammer-web-support/dist/location';

import config from '../../config';
type ReportBootstrapCompleted = (suiteHeaderTheme: SuiteHeaderTheme) => void;

export const reportBootstrapStarted: VoidFunction = () => {
  reportInfo({
    eventName: 'bootstrap_started',
    eventProperties: {
      ...getBrowserInfo(),
      urlRootPath: getUrlRootPath(location.pathname),
    },
  });
};

export const reportStandaloneAppLaunched: VoidFunction = () => {
  if (getDisplayMode() === 'standalone') {
    reportUsage({ eventName: 'pwa_standalone_app_launched' });
  }
};

export const reportBootstrapCompleted: ReportBootstrapCompleted = (suiteHeaderTheme) => {
  reportUsage({
    eventName: 'bootstrap_completed',
    eventProperties: {
      isDarkTheme: suiteHeaderTheme.isInverted,
    },
  });
};

export const reportIsDomainRedirect: VoidFunction = () => {
  const isNewDomain = location.host === engageDomain;
  const isWebDomain = isNewDomain || location.host === glammerDomain;

  if (isWebDomain) {
    reportInfo({
      eventName: 'domain_migration_redirect',
      eventProperties: {
        ...getBrowserInfo(),
        isRedirectToNewDomain: isNewDomain,
        appBaseName: getBasenameForUrlPath(location.pathname),
      },
    });
  }
};

export const reportErrorWithCode: (error: ReportErrorOptions['error'], errorCode: ErrorCode) => void = (
  error,
  errorCode
) => {
  reportError({ error, eventProperties: { errorCode } });
};

export const setupLogging: VoidFunction = () => {
  setLogLevel(config.logging.logLevel);
};
